import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';

import { onAppModuleCreated } from './app-module-created';
import { RootComponent } from './components/root.component';
import { routing } from './components/root.routes';
import { PROD_MODE } from './config';
import { StaticLoader, StaticMissingTranslationHandler } from './i18n';
import { CustomLocation } from './shared/utils/location.custom';
import { beforeStart } from './before-start';

if (PROD_MODE) {
	enableProdMode();
}

async function startApplication() {
	const application = await bootstrapApplication(RootComponent, {
		providers: [
			importProvidersFrom(
				// thise import is needed for uses in services
				// eslint-disable-next-line deprecation/deprecation
				MatLegacyDialogModule,
				routing,
				TranslateModule.forRoot({
					loader: { provide: TranslateLoader, useClass: StaticLoader },
					missingTranslationHandler: {
						provide: MissingTranslationHandler, useClass: StaticMissingTranslationHandler
					}
				}),
			),
			{ provide: Location, useClass: CustomLocation },
			{
				provide: APP_INITIALIZER,
				multi: true,
				useFactory: () => beforeStart,
			},
			provideAnimations(),
			provideHttpClient(withInterceptorsFromDi())
		]
	});
	onAppModuleCreated(application);
}

startApplication()
	.catch(error => {
		console.error('error awaiting app start', error);
	});
